// extracted by mini-css-extract-plugin
var _1 = "c8V9K";
var _2 = "UCwG8";
var _3 = "y9qRS";
var _4 = "cfOyk";
var _5 = "f42Qi";
export { _1 as "action", _2 as "assigned", _3 as "avatar", _4 as "base", _5 as "status" }
